import { Component } from '@angular/core';
import { FiCountdownNotificationComponent } from '../notification/countdown-notification/countdown-notification.component';

@Component({
    selector: 'fi-inactivity-countdown-notification',
    templateUrl: './inactivity-countdown-notification.component.html',
    standalone: false,
})
export class FiInactivityCountdownNotificationComponent extends FiCountdownNotificationComponent {
    refreshSessionClick() {
        this.countdownNotification.params.refreshSession();
    }
}
